<template>
  <div>
    <v-breadcrumbs :items="breadCrumbs">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item @click="clickBreadCrumb(item.text)" :disabled="item.disabled" :link="true">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div v-if="detailLicense">
      <v-btn
          @click="detailLicense = null"
          class="ma-2"
          outlined
          x-small
          color="indigo"
      >
        Zurück
      </v-btn>
      <LicenseDetailItem style="margin: 24px;" :licence="detailLicense" @reload="loadData"/>
    </div>
    <v-row v-else>
      <v-col
          v-for="licence in licenses" :key="licence.id"
          cols="12"
          sm="4"
      >
        <CompanyLicenceItem :super-admin="false" @reload="loadData" :licence="licence" @details="setDetail(licence)"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import CompanyLicenceItem from "@/components/CompanyLicenceItem";
import LicenseDetailItem from "@/components/LicenceDetailItem";

export default {
  name: "Licenseverwaltung",
  components: {LicenseDetailItem, CompanyLicenceItem},
  data: () => ({
    licenses: [],
    detailLicense: null
  }),
  mounted() {
    this.loadData()
  },
  computed: {
    breadCrumbs() {
      if (this.detailLicense === null) {
        return [{
          text: "Lizenzen", disabled: true
        }]
      } else {
        return [{
          text: "Lizenzen", disabled: false, link: true
        }, {text: this.detailLicense.course.title, disabled: true, link: true}];
      }
    }
  },
  methods: {
    setDetail(detail) {
      this.detailLicense = detail;
    },
    clickBreadCrumb(text) {
      if (this.detailLicense && text === "Lizenzen") {
        this.detailLicense = null;
        this.loadData();
      }
    },
    loadData() {
      this.$httpLicenseApi.getAll((licenses) => {
        this.licenses = licenses;
        if (this.detailLicense !== null) {
          this.detailLicense = licenses.find(element => element.id === this.detailLicense.id)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
